import initializeComponent from 'Shared/react-initialize';
import { LogIn } from './LogIn';

export const LogInPage = () => (
   <>
      <style>{`:where(body) { background-color: var(--color-gray-50); }`}</style>
      <div className="my-8 md:my-14 flex justify-center" data-testid="loginContainer">
         <LogIn />
      </div>
      <p
         dangerouslySetInnerHTML={{
            __html: App.dataProtectionMessage,
         }}
      />
   </>
);

initializeComponent('LogInPage', LogInPage);
